import React from 'react';

const LinkedInIcon: React.FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#linkedin-clip)">
        <path
          d="M14.8156 0.00390625H1.18125C0.528125 0.00390625 0 0.519531 0 1.15703V14.8477C0 15.4852 0.528125 16.0039 1.18125 16.0039H14.8156C15.4688 16.0039 16 15.4852 16 14.8508V1.15703C16 0.519531 15.4688 0.00390625 14.8156 0.00390625ZM4.74687 13.6383H2.37188V6.00078H4.74687V13.6383ZM3.55938 4.96016C2.79688 4.96016 2.18125 4.34453 2.18125 3.58516C2.18125 2.82578 2.79688 2.21016 3.55938 2.21016C4.31875 2.21016 4.93437 2.82578 4.93437 3.58516C4.93437 4.34141 4.31875 4.96016 3.55938 4.96016ZM13.6344 13.6383H11.2625V9.92578C11.2625 9.04141 11.2469 7.90078 10.0281 7.90078C8.79375 7.90078 8.60625 8.86641 8.60625 9.86328V13.6383H6.2375V6.00078H8.5125V7.04453H8.54375C8.85938 6.44453 9.63438 5.81016 10.7875 5.81016C13.1906 5.81016 13.6344 7.39141 13.6344 9.44766V13.6383Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="linkedin-clip">
          <rect width="16" height="16" fill="white" transform="translate(0 0.00390625)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default LinkedInIcon;
